import { useState } from "react";
import ConversasList from "./ConversasList";
import ChatView from "./ChatView";

// wrapperClass permite reuso fullscreen (página /chat) sem o cálculo de
// altura por tabs. Default: dentro da aba "Inbox" da página /whatsapp/oficial.
const DEFAULT_WRAPPER =
  "flex h-[calc(100vh-280px)] min-h-[400px] bg-base border border-white/[0.06] rounded-lg overflow-hidden";

export default function InboxLayout({ contaId, socket, wrapperClass }) {
  const [selectedConversaId, setSelectedConversaId] = useState(null);
  // Último evento de troca de modo (assumir/encerrar) — a lista usa pra tirar/pôr
  // a conversa na aba Atendimento sem esperar reload.
  const [modoEvent, setModoEvent] = useState(null);

  function handleSelect(id) {
    setSelectedConversaId(id);
  }

  function handleVoltar() {
    setSelectedConversaId(null);
  }

  return (
    <div
      className={wrapperClass || DEFAULT_WRAPPER}
      role="main"
      aria-label="Inbox de conversas WhatsApp"
    >
      {/* ---- Desktop: painel esquerdo (35%) ---- */}
      {/* Sempre visível em md+; oculto em mobile quando conversa aberta */}
      <section
        className={`flex-shrink-0 w-full md:w-[35%] border-r border-white/[0.06] flex flex-col ${
          selectedConversaId !== null ? "hidden md:flex" : "flex"
        }`}
        aria-label="Lista de conversas"
      >
        <ConversasList
          contaId={contaId}
          onSelect={handleSelect}
          selectedId={selectedConversaId}
          modoEvent={modoEvent}
          socket={socket}
        />
      </section>

      {/* ---- Desktop/Mobile: painel direito (65%) ---- */}
      {/* Em mobile: fullscreen quando conversa selecionada, oculto quando null */}
      <section
        className={`flex-1 flex flex-col min-w-0 ${
          selectedConversaId === null ? "hidden md:flex" : "flex"
        }`}
        aria-label="Visualizador de conversa"
      >
        <ChatView
          contaId={contaId}
          conversaId={selectedConversaId}
          onModoChange={(id, modo) => setModoEvent({ id, modo, ts: Date.now() })}
          socket={socket}
          onVoltar={selectedConversaId !== null ? handleVoltar : undefined}
        />
      </section>
    </div>
  );
}
